<aimo-cx-storefront
    [class.is-expanded]="isExpanded$ | async"
    [ngClass]="isPikatukku() ? 'aimo-pikatukku' : 'aimo-toimitustukku'"></aimo-cx-storefront>
<div class="cx-spinner modal fade show" id="aimo-spinner">
    <div class="modal-dialog modal-dialog-centered justify-content-center" role="document">
        <aimo-spinner></aimo-spinner>
    </div>
</div>
